// src/pages/History/20thCentury/RussianRevolution.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_Russian_Revolution_&_USSR.png';

function HistoryPageRussianRevolution() {
  return (
    <TopicPage
      topicKey="Russian Revolution & USSR"
      title="History: Russian Revolution & USSR"
      backgroundImage={bg}
      startRoute="/History-Russian-Revolution-Go"
      scrollLabels={[
        "Causes of the Revolution",
        "Bolsheviks and Lenin",
        "Life in the USSR",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageRussianRevolution;
